module.exports = __webpack_public_path__ + "media/images/SP-Águas-Branco-d3a61c8a7472029a429ec81236bdd188.png";